///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/collection-model.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ISmartMoverModel = Meevo.Components.Controls.SmartMover.ISmartMoverModel;
    import IReportTax = Meevo.Plugins.Reports.IReportTax;

    export class ReportTaxesModel extends SmartMoverModel<IReportTax> implements ISmartMoverModel<IReportTax> {
        get displayName(): string {
            return this.isActive ? this.get('displayName') : `${this.get('displayName')} - Inactive as of ${this.options.$filter<any>('meevodate')(this.get('dateUpdated'), 'MM/dd/y')}`;
        }

        get isActive(): boolean {
            return this.get('isActive');
        }
    }
}
